import { FC } from 'react'
import { useDispatch } from 'react-redux'

import CloseIcon from '@mui/icons-material/Close'
import { AppBar, Box, Grid, IconButton, Typography, useTheme } from '@mui/material'
import Dialog from '@mui/material/Dialog'


import { HEADER_HEIGHT } from 'utils/customizedTheme'

interface IProps {
  children?: JSX.Element
  toggleModal?: any
  width: string
  entityName?: string
  openModal: boolean
}

const Modal: FC<IProps> = ({ children, toggleModal, width, entityName, openModal }) => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(toggleModal(false))
  }

  return (
    <div>
      <Dialog
        onClose={handleClose}
        open={openModal}
        fullWidth
        maxWidth='xl'
        PaperProps={{
          sx: {
            margin: 0,
            padding: 0,
            minHeight: '80vh',
            width: width ? width : { xs: '100vw', md: '80vw' },
            background: theme.palette.background.default,
          },
        }}
      >
        <AppBar
          sx={{
            display: 'flex',
            position: 'relative',
            height: HEADER_HEIGHT,
            boxShadow: 'none'
          }}
        >
          <Grid sx={{ maxWidth: 'xl', height: '100%' }} m={'0 auto'} px={3} container>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                sx={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '2rem',
                  fontWeight: '300',
                  color: theme.palette.primary.contrastText,
                }}
              >
                {entityName}
              </Typography>
              <IconButton
                onClick={handleClose}
                aria-label='close'
                sx={{ marginRight: '-0.5rem', color: theme.palette.primary.contrastText }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </AppBar>

        <Box m={3} sx={{ overflow: 'auto', maxHeight: '100%' }}>
           {children}
        </Box>
      </Dialog>
    </div>
  )
}
export default Modal
